export default {
  getEducationLevel: (state) => state.educationalLevel,
  getRegions: (state) => state.regions,
  getAllDocumentSpecs: (state) => state.allDocumentSpecs,
};
